<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */

    /**
     * Component displays step progress in a form of counter.
     */

    /**
     * @typedef {Object} Props
     * @property {Number} position
     * @property {Number} total
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        position,
        total
    } = $props();
</script>

{#if position && total}
    <div class="counter">{position} / {total}</div>
{/if}
